module.exports = __webpack_public_path__ + "images/63aab2d07894c0a367273c2e0aa57ffb.svg";